import React from "react"
import { connect } from "react-redux"
import { motion, AnimatePresence } from "framer-motion"

import chevron_down from "../../images/icon/chevron-down.svg"

const ShopPopup = ({
  shopAnnouncementData,
  showShopAnnouncementBar,
  handleClick,
}) => {
  return (
    <AnimatePresence>
      {showShopAnnouncementBar && (
        <motion.div
          className={`shop-popup-container`}
          initial={{ y: "65px" }}
          animate={{ y: "0px" }}
          exit={{ y: "65px" }}
        >
          <div className="shop-popup-container__inner">
            <div className="dot-icon"></div>
            <p className="shop-popup-container__announcement">
              <span>{shopAnnouncementData}</span>
              <span role="button" onClick={() => handleClick()}>
                &nbsp;ADDED TO CART.
              </span>
            </p>
            <div role="button" tabIndex={0} onClick={() => handleClick()}>
              <span>VIEW CART</span>
              <img src={chevron_down} alt="View Cart" />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default connect(
  state => ({
    showShopAnnouncementBar: state.shop.showShopAnnouncementBar,
    shopAnnouncementData: state.shop.shopAnnouncementData,
  }),
  null
)(ShopPopup)
